import React from 'react'

const RechartCreator = ({ height = '320px', width = '100%', children }) => {
    return (
        <div style={{ height, width }}>
            
        </div>
    )
}

export default RechartCreator
